import ActivitiesTable from "@/components/ActivitiesTable";
import { useRequiredParam } from "@/layouts/Navigation/useRequiredParam";

const DestinationActivitiesTable = () => {
  const destinationID = useRequiredParam("destinationID");

  return (
    <ActivitiesTable
      destinationId={destinationID}
      emptyMessage="No activity found. Transfers to this destination will show up here."
    />
  );
};

export default DestinationActivitiesTable;
